(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("l8pe2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createActivityMonitor", {
    enumerable: true,
    get: function() {
        return $f62de996f7a7ea68$var$_userActivityMonitor.default;
    }
});
Object.defineProperty(module.exports, "createPollingService", {
    enumerable: true,
    get: function() {
        return $f62de996f7a7ea68$var$_pollingService.default;
    }
});

var $f62de996f7a7ea68$var$_userActivityMonitor = $f62de996f7a7ea68$var$_interopRequireDefault((parcelRequire("gLQpj")));

var $f62de996f7a7ea68$var$_pollingService = $f62de996f7a7ea68$var$_interopRequireDefault((parcelRequire("dfei9")));
function $f62de996f7a7ea68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("gLQpj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c359b0191195f512$var$_emitter = $c359b0191195f512$var$_interopRequireDefault((parcelRequire("78Nz3")));

var $lg0Zk = parcelRequire("lg0Zk");
function $c359b0191195f512$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c359b0191195f512$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $c359b0191195f512$var$INACTIVITY_THRESHOLD = 300; // 5 minutes.
class $c359b0191195f512$var$UserActivityMonitorImpl extends $c359b0191195f512$var$_emitter.default {
    // This value is negative so that we know if the user was ever active.
    constructor(window){
        super();
        $c359b0191195f512$var$_defineProperty(this, "_active", true);
        $c359b0191195f512$var$_defineProperty(this, "_inactivityTimeoutHandle", 0);
        $c359b0191195f512$var$_defineProperty(this, "_inactivityTimeoutSec", $c359b0191195f512$var$INACTIVITY_THRESHOLD);
        $c359b0191195f512$var$_defineProperty(this, "_lastActive", -1);
        $c359b0191195f512$var$_defineProperty(this, "setInactivityTimeout", void 0);
        $c359b0191195f512$var$_defineProperty(this, "document", void 0);
        const { clearTimeout: clearTimeout, document: document, setTimeout: setTimeout } = window;
        this.document = document;
        document.addEventListener("visibilitychange", ()=>this.onVisibilityChange());
        this.setInactivityTimeout = (0, $lg0Zk.throttleQueue)(()=>{
            this._inactivityTimeoutHandle && clearTimeout(this._inactivityTimeoutHandle);
            if (this._active) this._inactivityTimeoutHandle = setTimeout(()=>this.onInactive(), this._inactivityTimeoutSec * 1000);
        }, 1000, true, window);
        this.onActive();
    }
    configure({ inactivityTimeoutSec: inactivityTimeoutSec }) {
        if (inactivityTimeoutSec && inactivityTimeoutSec !== this._inactivityTimeoutSec) {
            this._inactivityTimeoutSec = inactivityTimeoutSec;
            if (this._active) this.setInactivityTimeout();
        }
    }
    onActive() {
        this._lastActive = Date.now();
        this.setInactivityTimeout();
        if (!this._active) {
            this._active = true;
            this.emit("active");
        }
    }
    onInactive() {
        if (this._active) {
            this._active = false;
            this.emit("inactive");
        }
    }
    onVisibilityChange() {
        if (this.document.hidden) {
            this.onInactive();
            this.emit("hidden");
        } else {
            this.onActive();
            this.emit("shown");
        }
    }
    registerActivityEmitter(emitter) {
        emitter.activityEvents && emitter.activityEvents.forEach((eventName)=>{
            emitter.on(eventName, ()=>this.onActive());
        });
    }
    get active() {
        return this._active;
    }
    get hidden() {
        return this.document.hidden;
    }
    get lastActive() {
        return this._lastActive;
    }
}
var $c359b0191195f512$var$_default = (win)=>new $c359b0191195f512$var$UserActivityMonitorImpl(win);
module.exports.default = $c359b0191195f512$var$_default;

});

parcelRegister("dfei9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lg0Zk = parcelRequire("lg0Zk");

var $f9A5f = parcelRequire("f9A5f");
function $9a47c32191d0741f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $9a47c32191d0741f$var$PollingServiceImpl {
    constructor(activityMonitor, metricsApi, win){
        $9a47c32191d0741f$var$_defineProperty(this, "_pollWhileInactive", true);
        $9a47c32191d0741f$var$_defineProperty(this, "_state", {});
        $9a47c32191d0741f$var$_defineProperty(this, "_activityMonitor", void 0);
        $9a47c32191d0741f$var$_defineProperty(this, "metrics", void 0);
        $9a47c32191d0741f$var$_defineProperty(this, "clearInterval", void 0);
        $9a47c32191d0741f$var$_defineProperty(this, "setInterval", void 0);
        // Listen to both inactive and hidden if we have 2 different frequencies for inactive/hidden.
        // Active should always be shown, so no need to listen to 'shown'.
        this.metrics = metricsApi.create("exc.module-runtime.network.pollingService");
        this.setInterval = win.setInterval.bind(win);
        this.clearInterval = (state)=>{
            if (state.intervalHandle) {
                win.clearInterval(state.intervalHandle);
                delete state.intervalHandle;
            }
        };
        const updateFn = ()=>this.updateAllIntervals();
        const throttledFn = (0, $lg0Zk.throttleQueue)(updateFn, 16, false, win);
        this._activityMonitor = activityMonitor;
        this._activityMonitor.on("inactive", throttledFn);
        this._activityMonitor.on("hidden", throttledFn);
        this._activityMonitor.on("active", updateFn);
    }
    async poll(state) {
        const { poller: poller } = state;
        const timer = this.metrics.start(`Polling.${poller.name}`);
        try {
            await poller.pollFn();
            state.lastPoll = Date.now();
            timer.time("done");
        } catch (err) {
            timer.time("PollFailed", {
                error: (0, $lg0Zk.getErrorMessage)(err)
            }, {
                level: $f9A5f.Level.ERROR
            });
        }
    }
    updatePollerState(state) {
        const { poller: poller, frequencyMs: frequencyMs, lastPoll: lastPoll } = state;
        const { activeFrequency: activeFrequency, hiddenFrequency: hiddenFrequency, inactiveFrequency: inactiveFrequency } = poller;
        let newFrequency = activeFrequency;
        if (!this._activityMonitor.active) {
            newFrequency = !this._activityMonitor.hidden || hiddenFrequency === undefined ? inactiveFrequency : hiddenFrequency;
            if (!this._pollWhileInactive) // Polling disabled during inactivity.
            newFrequency = 0;
        }
        if (frequencyMs !== newFrequency) {
            // Frequency set or updated.
            this.clearInterval(state);
            state.frequencyMs = newFrequency;
            state.intervalHandle = newFrequency > 0 ? this.setInterval(()=>this.poll(state), newFrequency) : 0;
            if (this._activityMonitor.active && newFrequency && Date.now() - lastPoll > newFrequency) this.poll(state);
        }
    }
    updateAllIntervals() {
        Object.values(this._state).forEach((state)=>this.updatePollerState(state));
    }
    configure({ pollWhileInactive: pollWhileInactive }) {
        if (pollWhileInactive !== undefined) {
            this._pollWhileInactive = pollWhileInactive;
            this.metrics.log("Polling configured", {
                pollWhileInactive: this._pollWhileInactive
            });
            this.updateAllIntervals();
        }
    }
    addPoller(poller) {
        const handle = `${poller.name}-${Date.now()}`;
        const state = this._state[handle] = {
            frequencyMs: 0,
            intervalHandle: 0,
            lastPoll: Date.now(),
            poller: poller
        };
        this.updatePollerState(state);
        if (poller.immediate) this.poll(state);
        return {
            handle: handle
        };
    }
    removePoller({ handle: handle }) {
        const state = this._state[handle];
        if (state) {
            this.clearInterval(state);
            delete this._state[handle];
        }
    }
}
var $9a47c32191d0741f$var$_default = (activityMonitor, metrics, win)=>new $9a47c32191d0741f$var$PollingServiceImpl(activityMonitor, metrics, win);
module.exports.default = $9a47c32191d0741f$var$_default;

});


})();
//# sourceMappingURL=polling.926195c9.js.map
